export default __webpack_public_path__ + "c59e400fb2f2fd5b764b0578c308a083.png";